import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/logo.svg";
import { resetPassword } from "../../../API/auth";
import getErrorMessage from "../../../Utlis/ErrorMessage";
import PortalConfig, {
  getResetPasswordPortal,
  clearResetPasswordPortal,
} from "../../../Utlis/PortalConfig";
import "./style.css";

const ResetPassword = ({ setUser, portal }) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const linkPortal = searchParams.get("portal");
  const [resolvedPortal] = useState(() =>
    PortalConfig[linkPortal]
      ? linkPortal
      : getResetPasswordPortal() || portal,
  );
  const config = PortalConfig[resolvedPortal];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    if (!token) {
      message.error("This reset link is invalid or has expired.");
      return;
    }

    setLoading(true);
    const res = await resetPassword({
      token,
      new_password: values.password,
    });
    setLoading(false);

    if (res?.status === 200) {
      message.success(
        getErrorMessage(res, "Your password has been reset successfully."),
      );
      clearResetPasswordPortal();
      setUser(config.userValue);
      navigate(config.loginRoute);
    } else {
      message.error(getErrorMessage(res, "Could not reset password."));
    }
  };

  const handleBackToLogin = () => {
    setUser(config.userValue);
    navigate(config.loginRoute);
  };

  return (
    <div className="reset">
      <div className="reset-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="reset-card">
          <div className="top-gradient"></div>
          <div className="content-heading">Set a New Password</div>
          <div className="sub-heading">
            Your new password must be different from previously used
            passwords.
          </div>
          <Form
            name="reset-password"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item
              label="New Password"
              name="password"
              hasFeedback
              rules={[
                { required: true, message: "Please enter a new password!" },
                {
                  min: 6,
                  message: "Password must be at least 6 characters!",
                },
              ]}
            >
              <Input.Password
                placeholder="Enter new password"
                prefix={<LockOutlined />}
              />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              dependencies={["password"]}
              hasFeedback
              rules={[
                { required: true, message: "Please confirm your password!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords do not match!"),
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Confirm new password"
                prefix={<LockOutlined />}
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              Reset Password
            </Button>

            <Button className="back-to-login" onClick={handleBackToLogin}>
              <ArrowLeftOutlined />
              Back to Login
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
